import React from 'react';
import './ExternalLinks.css';
import { useAuth } from '../AuthContext';
import { usePermissions } from '../PermissionsContext';

const ExternalLinks = () => {
  const { user } = useAuth();
  const { getAccessibleLinks, nameOverride } = usePermissions();

  // Get links the current user can access
  const accessibleLinks = getAccessibleLinks(user?.name);
  
  // Display which name is being used
  const displayName = nameOverride || user?.name;

  const getHref = (url) => /^https?:\/\//i.test(url) ? url : `https://${url}`;

  return (
    <div className="external-links-container">
      <h2>External Links</h2>
      {nameOverride && (
        <div className="testing-mode-banner">
          Testing as: <strong>{nameOverride}</strong>
        </div>
      )}
      <div className="links-grid">
        {accessibleLinks.length > 0 ? (
          accessibleLinks.map((link) => (
            <a key={link.id} href={getHref(link.url)} target="_blank" rel="noopener noreferrer" className="link-button">
              {link.name}
            </a>
          ))
        ) : (
          <div className="no-links-message">
            No links available for {displayName}
          </div>
        )}
      </div>
    </div>
  );
};

export default ExternalLinks;
